import { createStyles, makeStyles } from '@hawkins/styles';
export var formFieldContainerStyles = function (theme) {
    var hawkins = theme.hawkins, hawkinsVariables = theme.hawkinsVariables;
    return createStyles({
        /** Class name to apply to the root of the container */
        root: {},
        /** Class name to apply to the root when fullWidth is true */
        fullWidth: {
            width: '100%',
        },
        /** Class name to apply to the root when compact is true */
        compact: {
            '& $label': {
                fontSize: hawkinsVariables.fontSizes.fontSize0,
            },
            '& $validationMessage': {
                fontSize: hawkinsVariables.fontSizes.fontSize0,
            },
            '& $description': {
                fontSize: hawkinsVariables.fontSizes.fontSize0,
            },
        },
        /** Class name to apply to the outer container that contains the label and description */
        labelContainer: {
            marginBottom: hawkinsVariables.spacings.space1,
        },
        /** Class name to apply to the label */
        label: {
            color: hawkins.textColor.textColorRegular,
            fontSize: hawkinsVariables.fontSizes.fontSize2,
            fontWeight: hawkinsVariables.fontWeights.fontWeight1,
        },
        labelWithAdornmentContainer: {
            display: 'flex',
            justifyContent: 'space-between',
        },
        labelAdornment: {
            '&::after': {
                display: 'inline-block',
                paddingLeft: hawkinsVariables.spacings.space0,
                fontWeight: 'normal',
            },
        },
        requiredAdornment: {
            '&::after': {
                content: '"(required)"',
                color: hawkins.textColor.textColorLight,
            },
        },
        requiredStarAdornment: {
            '&::after': {
                content: '"*"',
                color: hawkins.textColor.textColorInformationError,
            },
        },
        requiredStarAdornmentMonochrome: {
            '&::after': {
                color: hawkins.textColor.textColorLight,
            },
        },
        optionalAdornment: {
            '&::after': {
                content: '"(optional)"',
                color: hawkins.textColor.textColorLight,
            },
        },
        /** Class name to apply to the description */
        description: {
            color: hawkins.textColor.textColorLight,
            display: 'block',
            fontSize: hawkinsVariables.fontSizes.fontSize1,
            fontWeight: 400,
            marginTop: hawkinsVariables.spacings.space0,
        },
        /** Class name of the validation message container. */
        validationMessage: {
            fontSize: hawkinsVariables.fontSizes.fontSize1,
            marginTop: hawkinsVariables.spacings.space0,
        },
        /** Class name of the error validation message container. */
        errorMessage: {
            color: hawkins.textColor.textColorInformationError,
        },
        /** Class name of the warning validation message container. */
        warningMessage: {
            color: hawkins.textColor.textColorInformationWarning,
        },
        /** Class name of the success validation message container. */
        successMessage: {
            color: hawkins.textColor.textColorInformationSuccess,
        },
    });
};
export var useFormFieldContainerStyles = makeStyles(formFieldContainerStyles, {
    name: 'Hawkins-FormFieldContainer',
});
